import { motion, useAnimation } from 'framer-motion'
import SVGJSContainer, {
	staggerChildren,
	staggerChildrenList,
	textVariants
} from '../../../utils/SVGJSContainer'
import NumberAnimate from '../../NumberAnimate'

function Promouvoir4() {
	const controls = useAnimation()

	return (
		<SVGJSContainer controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="829.963"
				height="797"
				viewBox="0 0 829.963 797"
			>
				<g data-name="Groupe 2569" transform="translate(-201 -3432.744)">
					<motion.text
						data-name="Essential coats what"
						fontFamily="AcuminPro-Regular, Acumin Pro"
						fontSize="28"
						letterSpacing="-.01em"
						transform="translate(607.963 4048.744)"
						variants={textVariants}
						initial="hidden"
						animate={controls}
					>
						<tspan x="0" y="21">
							opérations Plan Climat{' '}
						</tspan>
						<tspan x="0" y="52">
							supplémentaires en 2023{' '}
						</tspan>
						<tspan x="0" y="83">
							(soit 340 logements)
						</tspan>
					</motion.text>

					<motion.text
						data-name="Mis en chantier"
						fontFamily="AcuminPro-Regular, Acumin Pro"
						fontSize="40"
						letterSpacing="-.02em"
						transform="translate(429.244 3575.744)"
						variants={textVariants}
						initial="hidden"
						animate={controls}
					></motion.text>
					<text
						data-name="0"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="80"
						fontWeight="700"
						transform="translate(589.977 4027.744)"
					>
						<tspan x="0" y="0">
							<NumberAnimate
								tspan
								prefix="+"
								nb={14}
								duration={2}
								delay={0.7}
							/>
						</tspan>
					</text>
					<motion.g
						data-name="Groupe 2543"
						transform="translate(-333.087 -80.937)"
						variants={staggerChildren}
						initial="hidden"
						animate={controls}
					>
						<motion.g
							data-name="Rectangle 2251"
							transform="rotate(90 -1508.362 2129.522)"
							variants={staggerChildrenList}
						>
							<path
								fill="#00758d"
								d="M0 0H632.117V87.074H0z"
								data-name="Rectangle 2257"
							></path>
							<path
								fill="none"
								d="M0 0H631.331V86.732H0z"
								data-name="Rectangle 2258"
								transform="translate(.393 .171)"
							></path>
						</motion.g>
						<motion.g
							fill="#00849b"
							data-name="Rectangle 2252"
							transform="rotate(90 -1496.681 2141.202)"
							variants={staggerChildrenList}
						>
							<path
								d="M0 0H632.117V87.074H0z"
								data-name="Rectangle 2259"
							></path>
							<path
								d="M0 0H631.331V86.732H0z"
								data-name="Rectangle 2260"
								transform="translate(.393 .171)"
							></path>
						</motion.g>
						<motion.g
							fill="#039db8"
							data-name="Rectangle 2253"
							transform="rotate(90 -1485 2152.883)"
							variants={staggerChildrenList}
						>
							<path
								d="M0 0H632.117V87.074H0z"
								data-name="Rectangle 2261"
							></path>
							<path
								d="M0 0H631.331V86.732H0z"
								data-name="Rectangle 2262"
								transform="translate(.393 .171)"
							></path>
						</motion.g>
						<motion.g
							fill="#4cbdd1"
							data-name="Rectangle 2254"
							transform="rotate(90 -1473.32 2164.563)"
							variants={staggerChildrenList}
						>
							<path
								d="M0 0H632.117V87.074H0z"
								data-name="Rectangle 2263"
							></path>
							<path
								d="M0 0H631.331V86.732H0z"
								data-name="Rectangle 2264"
								transform="translate(.393 .171)"
							></path>
						</motion.g>
						<motion.g
							fill="#76bdca"
							data-name="Rectangle 2255"
							transform="rotate(90 -1484.773 2153.11)"
							variants={staggerChildrenList}
						>
							<path
								d="M0 0H632.117V87.074H0z"
								data-name="Rectangle 2265"
							></path>
							<path
								d="M0 0H631.331V86.732H0z"
								data-name="Rectangle 2266"
								transform="translate(.393 .171)"
							></path>
						</motion.g>
						<motion.g
							fill="#a5c8cc"
							data-name="Rectangle 2256"
							transform="rotate(90 -1454.548 2183.335)"
							variants={staggerChildrenList}
						>
							<path
								d="M0 0H632.117V47.968H0z"
								data-name="Rectangle 2267"
							></path>
							<path
								d="M0 0H631.331V47.626H0z"
								data-name="Rectangle 2268"
								transform="translate(.393 .171)"
							></path>
						</motion.g>
					</motion.g>
					<motion.path
						fill="none"
						stroke="#000"
						strokeWidth="2"
						d="M201 4199.744h197.125l184.883-184.883"
						data-name="Tracé 30526"
						variants={textVariants}
						initial="hidden"
						animate={controls}
					></motion.path>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default Promouvoir4
